import moment from "moment";
import { AnnualLeaveKey } from "@/constants/globalConstants";
import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../constants/Settings";

export class LeaveApp {
  TxNum;
  UserID;
  DateApp;
  DateFrom;
  DateTo;
  DaysHrs;
  QtyDaysHrs;
  LeaveType;
  Remark;
  Approved;
  RejReason;
  ProcBy;
  DateProc;
  AddBy;
  DateAdd;
  ModifyBy;
  DateModify;
  UserName;
  RecDel;
  AttachmentList;
  IsCancelled;
  CancelReason;
  HaveAttachments;
  constructor() {
    const sysParams = store.getters[StoreGetter.sysParams];
    const dayStart = sysParams.find(x => x.ParamCode === Settings.SysParams.DayStart);
    const dayEnd = sysParams.find(x => x.ParamCode === Settings.SysParams.DayEnd);
    this.TxNum = "";
    this.UserID = "";
    this.DateApp = moment(new Date()).format("YYYY-MM-DD");
    this.DateFrom = `${moment(new Date()).format("YYYY-MM-DD")} ${dayStart.ParamVal}`;
    this.DateTo = `${moment(new Date()).format("YYYY-MM-DD")} ${dayEnd.ParamVal}`;
    this.DaysHrs = "Days";
    this.QtyDaysHrs = 1;
    this.LeaveType = AnnualLeaveKey;
    this.Remark = "";
    this.Approved = "";
    this.RejReason = "";
    this.ProcBy = "";
    this.DateProc = moment(new Date()).format("YYYY-MM-DD");
    this.AddBy = "";
    this.DateAdd = moment(new Date()).format("YYYY-MM-DD");
    this.ModifyBy = "";
    this.DateModify = moment(new Date()).format("YYYY-MM-DD");
    this.UserName = "";
    this.RecDel = false;
    this.AttachmentList = [];
    this.IsCancelled = false;
    this.CancelReason = "";
    this.HaveAttachments = false;
  }
}



// WEBPACK FOOTER //
// ./src/model/LeaveApp.js